import { createUseStyles } from 'react-jss'
import { colors, zIndexes } from '#base/js/variables.style'

const hoverBorder = `1px solid ${colors.metallicSeaweed}`
const actionsAreaHeight = 31
export const blockHighlight = {
  margin: 0,
  border: hoverBorder
}

export const style = {
  actionsWrapper: {
    position: 'relative',
    '&:hover': {
      margin: '-1px 0'
    },
    '&:hover $actionsArea': {
      visibility: (props) => props && props.enabled ? 'visible' : 'hidden'
    },
    '&:hover $innerWrapper': {
      margin: (props) => props && props.enabled ? blockHighlight.margin : 1,
      border: (props) => props && props.enabled ? blockHighlight.border : 'none',
      marginTop: -1
    }
  },
  innerWrapper: {},
  actionsArea: {
    display: 'flex',
    position: 'absolute',
    top: -actionsAreaHeight,
    right: 0,
    visibility: 'hidden',
    zIndex: zIndexes.editableBlockActionsArea,
    '&:hover': {
      visibility: (props) => props && props.enabled ? 'visible' : 'hidden'
    }
  },
  actionsAreaHoverExtend: {
    width: 100,
    height: actionsAreaHeight
  },
  actions: {
    display: 'flex',
    borderTop: hoverBorder,
    borderRight: hoverBorder,
    borderLeft: hoverBorder,
    backgroundColor: colors.metallicSeaweed,
    color: 'white',
    fontSize: 16,
    '& div': {
      cursor: 'pointer',
      padding: '6px 10px 4px'
    },
    '& div:hover': {
      color: colors.metallicSeaweed,
      backgroundColor: colors.backgroundGray,
      borderBottom: hoverBorder
    }
  }
}

export const useStyles = createUseStyles(style)
